export default __webpack_public_path__ + "static/Perroquet-fond-dcd9d00d092bfb117db3301aadfe066f.jpg";